import mitt from "mitt";
import { showNotification, hideNotification } from "./notification";

const eventBus = mitt();

eventBus.on("show-notification", showNotification);
eventBus.on("hide-notification", hideNotification);

export default eventBus;
